enum JourneyCalculationType {
    Manual	= 0,
    Template = 1,
 
}
export default JourneyCalculationType;